export default "__VITE_ASSET__GfCNEcwY__"